/**
 * @author mrdoob / http://mrdoob.com/
 */

import SelectorNodeTab from './SelectorNodeTab'
import SettingsTab from './SettingsTab'
import OverlayTab from './OverlayTab'
import PropertyTab from './PropertyTab'
import SetDesignTab from './SetDesignTab'
import SoundTab from './SoundTab'
import SceneExperienceTab from './SceneExperienceTab'
import AssetSelectorTab from './AssetSelectorTab'
import UserTab from './UserTab'
import LogicTab from './LogicTab'
//import LinkTab from './LinkTab'
import TabHeader from './TabHeader'
import UI from './libs/ui'
import ChatbotTab from './ChatbotTab'
import AnimationTab from './AnimationTab'
import VoiceTab from './VoiceTab'
import CharactorSelectorTab from './CharacterSelectorTab'
var Sidebar = function ( editor ) {

	var signals = editor.signals;

	var container = new UI.Panel();
	container.setId( 'sidebar' );

	var selectorTab = new UI.Text( 'Select Clip Type' ).onClick( onClick ).setId('tabHeading')
	var settingsTab = new UI.Text( 'Setting' ).onClick( onClick ).setId('tabHeading')
	var overlayTab = new UI.Text( 'Overlay' ).onClick( onClick ).setId('tabHeading')
	var setDesignTab = new UI.Text( 'Set Design' ).onClick( onClick ).setId('tabHeading')
	var propertyTab = new UI.Text('Prop').onClick( onClick ).setId('tabHeading')
	var soundTab = new UI.Text( 'Sound' ).onClick( onClick ).setId('tabHeading')
	var sceneExperienceTab = new UI.Text( 'Scene Experience' ).onClick( onClick ).setId('tabHeading')
	var assetSelectorTab = new UI.Text('Asset Selector').onClick(onClick).setId('tabHeading')
	var chatbotTab = new UI.Text('Chatbot Tab').onClick(onClick).setId('tabHeading')
	var animationTab = new UI.Text('Animation').onClick(onClick).setId('tabHeading')
	var voiceTab = new UI.Text('Voice Tab').onClick(onClick).setId('tabHeading')
	var characterSelectorTab = new UI.Text('Character Selector Tab').onClick(onClick).setId('tabHeading')
	//editAssetButton.dom.appendChild(icon);

	var userTab = new UI.Text('User Logic').onClick(onClick);
	var logicTab = new UI.Text('Logic text').onClick(onClick);
	//var linkTab = new UI.Text('Link text').onClick(onClick);

	var tabs = new UI.Div();
	tabs.setId( 'tabs' );
	container.add( tabs );

	function onClick( event ) {

		// select( event.target.textContent );

	}

	var voice = new UI.Span().add(
		new VoiceTab(editor)
	)
	container.add(voice)

	var characterSelector = new UI.Span().add(
		new CharactorSelectorTab(editor)
	)
	container.add(characterSelector)

	var animation = new UI.Span().add(
		new AnimationTab(editor)
	)
	container.add(animation)

	var chatbot = new UI.Span().add(
		new ChatbotTab( editor )
	)
	container.add(chatbot)

	var user = new UI.Span().add(
		new UserTab( editor )
	)
	container.add(user)

	var logic = new UI.Span().add(
		new LogicTab(editor)
	)
	container.add(logic)

	// var link = new UI.Span().add(
	// 	new LinkTab(editor)
	// )
	// container.add(link)

	var tabHeader = new UI.Span().add(
		new TabHeader ( editor )
	);
	container.add(tabHeader)

	var selector = new UI.Span().add(
		new SelectorNodeTab( editor )
	);
	container.add( selector );

	var settings = new UI.Span().add(
		new SettingsTab( editor )
	);
	container.add( settings );

	var overlay = new UI.Span().add(
		new OverlayTab( editor )
	);
	container.add( overlay );

	var property = new UI.Span().add(
		new PropertyTab( editor )
	);
	container.add( property );

	var setDesign = new UI.Span().add(
		new SetDesignTab(editor)
	);
	container.add(setDesign);

	var sound = new UI.Span().add(
		new SoundTab( editor )
	);
	container.add( sound );


	var sceneExperience = new UI.Span().add(
		new SceneExperienceTab( editor )
	);
	container.add( sceneExperience );

	var assetSelector = new UI.Span().add(
		new AssetSelectorTab(editor)
	)
	container.add(assetSelector);

	function select( section ) {

		hideAllTabs()

		switch ( section ) {
			case 'Select Clip Type':
				showTab(selectorTab, selector)
				break;
			case 'Settings':
				showTab(settingsTab, settings)
				break;
			case 'Overlay':
				showTab(overlayTab, overlay)
				break;
			case 'Property':
				showTab(propertyTab, property)
				break;
			case 'Set Design':
				showTab(setDesignTab, setDesignTab)
				break;
			case 'Sound':
				showTab(soundTab, sound)
				break;
			case 'Scene Experience':
				showTab(sceneExperienceTab, sceneExperience)
				break;
		}
	}
	// select( '' );

	function hideTab(tab, tabComponent) {
		tab.setClass( '' )
		tabComponent.setDisplay( 'none' )
	}

	function showTab(tab, tabComponent) {
		tab.setClass( 'selected' );
		tabComponent.setDisplay( '' );
	}

	function hideAllTabs() {
		hideTab(selectorTab, selector)
		hideTab(settingsTab, settings)
		hideTab(overlayTab, overlay)
		hideTab(propertyTab, property)
		hideTab(soundTab, sound)
		hideTab(overlayTab, overlay)
		hideTab(sceneExperienceTab, sceneExperience)
		hideTab(assetSelectorTab, assetSelector)
		hideTab(userTab, user)
		hideTab(logicTab, logic)
		hideTab(setDesignTab, setDesign)
		hideTab(chatbotTab, chatbot)
		hideTab(animationTab, animation)
		hideTab(voiceTab, voice)
		hideTab(characterSelectorTab, characterSelector)
		//hideTab(linkTab, link)
		hideTabHeader()
	}

	signals.showSelector.add(function (node) {
		tabs.clear()
		hideAllTabs()
		if (node.data.category === 'Chatbot') {
			showTab(characterSelectorTab, characterSelector)
		}
	})

	signals.panelNodeSelected.add(function (node) {
		tabs.clear()
		hideAllTabs()
		if (node.data.category === 'Chatbot') {
			showTab(chatbotTab, chatbot)
		}
	})

	signals.animationTypeChange.add(function (animation) {
		signals.animationSelected.dispatch(animation);
	} );

	signals.animationPhaseChanged.add(function (animation) {
		if (animation.phase === 'needsAsset') {
			tabs.clear()
			hideAllTabs()
			tabs.add(assetSelectorTab)
			showTab(assetSelectorTab, assetSelector)
			showTabHeader()
		}
		else {
			signals.animationTypeChange.dispatch(animation);
		}
	});

	function showTabHeader() {
		tabHeader.setDisplay('')
	}

	function hideTabHeader() {
		tabHeader.setDisplay('none')
	}

	signals.nodeSelected.add(function (node) {
		tabs.clear()
		hideAllTabs()
		// if (node.data.category === 'User') {
		// 	showTab(userTab, user)
		// } else 
		// if (node.data.category === 'Logic') {
		// 	showTab(logicTab, logic)
		// }
		//  else if (node.data.category === 'Chatbot') {
		// 	showTab(chatbotTab, chatbot)
		// }
		// else if (node instanceof go.Link) {
		// 	showTab(linkTab, link)
		// }

	})

	signals.animationSubComponentSelected.add( function ( element, anim) {
		tabs.clear()
		hideAllTabs()

		if (element.animation) {
			tabs.add(animationTab)
			showTab(animationTab, animation)
		} else if (element.line) {
			tabs.add(voiceTab)
			showTab(voiceTab, voice)
		}
	})

	signals.animationSelected.add( function ( animation ) {
		tabs.clear()
		hideAllTabs()

		// clear sidebar on null
		if (!animation) return

		if (animation.phase === 'needsAsset'){
			showTabHeader()
			tabs.add(assetSelectorTab)
			showTab(assetSelectorTab, assetSelector)
		} else if (animation.type === 'Unassigned Node') {
			hideTabHeader()
			showTab(selectorTab, selector)
			tabs.add(selectorTab)
		} else if (animation.type === 'Character') {
			showTabHeader()
			showTab(settingsTab, settings)
			tabs.add(settingsTab)
		} else if (animation.type === 'Prop') {
			showTabHeader()
			showTab(propertyTab, property)
			tabs.add(propertyTab)
		} else if (animation.type === 'Set Design') {
			showTabHeader()
			showTab(setDesignTab, setDesign)
			tabs.add(setDesignTab)
		} else if (animation.type === 'Experience') {
			showTabHeader()
			showTab(sceneExperienceTab, sceneExperience)
			tabs.add(sceneExperienceTab)
		} else if (animation.type === 'Sound') {
			showTabHeader()
			showTab(soundTab, sound)
			tabs.add(soundTab)
		} else if (animation.type === 'Overlay') {
			showTabHeader()
			showTab(overlayTab, overlay)
			tabs.add(overlayTab)
		}
	} );

	return container;

};

export default Sidebar



//////////////////
// WEBPACK FOOTER
// ./external_libs/frame.js/editor/js/Sidebar.js
// module id = null
// module chunks = 